module.exports = __webpack_public_path__ + "img/sojournary.a8f5bfcc.jpg";